import React from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { InputNumber, InputSizes, Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import styles from '../styles/availableBalanceForm.module.scss';

function DoubleDipCapCard({ value, enabled, onChange, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Double-Dip Cap"
            icon={<SwapOutlined />}
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
            togglePosition="trailing"
        >
            <div className={styles.cardInputRow}>
                <InputNumber
                    size={InputSizes.SMALL}
                    defaultValue={value}
                    onChange={onChange}
                    min={0}
                    max={100}
                    controls={false}
                    disabled={!enabled}
                    prefix={<Text as={TextAs.SPAN} size={TextSizes.SMALL}>%</Text>}
                    className={`${styles.inlineNumberInput} ${styles.percentField}`}
                />
            </div>
        </ConfigurationCard>
    );
}

export default DoubleDipCapCard;
